// eslint-disable-next-line @typescript-eslint/naming-convention
export enum WHITE_LIST {
  AI_LAB = 'aigc_all',
  SHOPPING_HELP = 'aiGuide_all',
  NOTHING = '',
};
